import CreateAccountRequest from './Accounts';
import PostcodeSearchRequest from './Addresses';
import { CreateApplicationRequest, UpdateApplicationRequest } from './Applications';
import { IssueCardRequest, ActivateCardRequest } from './Cards';
import CompaniesSearchRequest from './Companies';
import ConnectRequest from './Connections';
import { SignContractRequest, GenerateContractRequest } from './Contracts';
import { CreateCredentialsRequest, UpdateCredentialsRequest } from './Credentials';
import LatestDecisionRequest from './Decisions';
import GetDocumentRequest from './Documents';

var wrapper = {
    CreateAccountRequest,
    PostcodeSearchRequest,
    CreateApplicationRequest,
    UpdateApplicationRequest,
    IssueCardRequest,
    ActivateCardRequest,
    CompaniesSearchRequest,
    ConnectRequest,
    SignContractRequest,
    GenerateContractRequest,
    CreateCredentialsRequest,
    UpdateCredentialsRequest,
    LatestDecisionRequest,
    GetDocumentRequest
};

export default wrapper;



// WEBPACK FOOTER //
// ./src/Resources/index.js